<div class="delete-dialog">
    <div class="delete-header">
        <i class="pi pi-exclamation-triangle text-4xl text-red-500 mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">Delete Pipeline</h3>
        <p class="text-gray-600">Are you sure you want to delete this pipeline?</p>
    </div>

    <div class="delete-content">
        <div class="pipeline-info">
            <div class="info-item">
                <span class="label">Pipeline Name:</span>
                <span class="value">{{ editPipelineData?.pipeline_name }}</span>
            </div>
            <div class="info-item">
                <span class="label">Pipeline Type:</span>
                <span class="value">{{ editPipelineData?.pipeline_type | titlecase }}</span>
            </div>
            <div class="info-item">
                <span class="label">Total Stages:</span>
                <span class="value">{{ editPipelineData?.stages?.length || 0 }}</span>
            </div>
            <div class="info-item" *ngIf="editPipelineData?.set_default">
                <span class="label">Status:</span>
                <span class="value badge-default">Default Pipeline</span>
            </div>
        </div>

        <div class="warning-message">
            <i class="pi pi-info-circle"></i>
            <p>This action cannot be undone. All stages associated with this pipeline will also be deleted.</p>
        </div>
    </div>

    <div class="delete-footer">
        <button 
            type="button" 
            pButton 
            label="Cancel" 
            class="p-button-outlined"
            (click)="onClose()"
            [disabled]="loading">
        </button>
        <button 
            type="button" 
            pButton 
            label="Delete" 
            class="p-button-danger"
            (click)="onDelete()"
            [loading]="loading"
            icon="pi pi-trash">
        </button>
    </div>
</div>
